
















































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import topTitle from "@/components/faceCoupon/topTitle.vue";
import topStep from "@/components/faceCoupon/topStep.vue";

const faceIntegralSuccess = namespace("faceIntegral");
@Component({
  components: {
    topStep,
    topTitle
  }
})
export default class FaceIntegralSuccess extends Vue {
  @faceIntegralSuccess.State("integralData") integralData!: any;
  @faceIntegralSuccess.State("detailData") detailData!: any;
  titleName: string = "面对面积分";
  /* 步骤 */
  stepsArry: Object = [
    { num: 1, name: "查询会员", class: "active" },
    { num: 2, name: "确认身份", class: "active" },
    { num: 3, name: "为会员积分", class: "active" },
    { num: 4, name: "完成", class: "active" }
  ]; 
  amount: any ;
  new_createTime: any='';
  mounted() {
    this.amount = this.integralData.amount/100;
    this.new_createTime = this.$router.app.$format(this.integralData.createTime, "YYYY.MM.DD  hh:mm:ss");
    console.log(this.new_createTime)
  }
  backHome() {
    this.$router.push({ path: "/home" });
  }
}
